import Vue from 'vue'
import Router from 'vue-router'

import home_index from '@/components/views/home_index'
import home_server from '@/components/views/home_server'
import home_help from '@/components/views/home_help'
import help_show from '@/components/views/help_show'
import home_users from '@/components/views/home_users'
import server_user_release from '@/components/views/server_user_release'
import server_user_list from '@/components/views/server_user_list'
import server_project_release from '@/components/views/server_project_release'
import mall_list from '@/components/views/mall_list'
import mall_show from '@/components/views/mall_show'
import user_help_release from '@/components/views/user_help_release'
import charitable_list from '@/components/views/charitable_list'
import charitable_show from '@/components/views/charitable_show'
import user_help_list from '@/components/views/user_help_list'
import user_order_list from '@/components/views/user_order_list'
import user_server_list from '@/components/views/user_server_list'
import user_tidings_list from '@/components/views/user_tidings_list'
import user_collection_list from '@/components/views/user_collection_list'
import location from '@/components/views/location'
import location1 from '@/components/views/location1'
import exchange from '@/components/views/exchange'
import details from '@/components/views/details'
import server_user_shows from '@/components/views/server_user_shows'
import user_help_save from '@/components/views/user_help_save'
import modifydata from '@/components/views/modifydata'
import user_examine_list from '@/components/views/user_examine_list'
import user_help_comment from '@/components/views/user_help_comment'
import ceshi from '@/components/views/ceshi'
import login from '@/components/views/login'
import help_clause from '@/components/views/help_clause'

//new——web
import web_index from '@/components/views/web/index' //首页
import web_users_index from '@/components/views/web/users/index' //用户
//admin
import admin_login from '@/components/views/admin/login' //登陆
import admin_template_main from '@/components/views/admin/_layout/template_main' //模版main
import admin_template_a from '@/components/views/admin/_layout/template_a' //模版a
import admin_index from '@/components/views/admin/index' //首页
import attribute from '@/components/views/admin/body/attribute' //用户
import order from '@/components/views/admin/body/order' //订单
import assistance from '@/components/views/admin/body/assistance' //帮扶 assistance
import money from '@/components/views/admin/body/money' //红包 money
import task from '@/components/views/admin/body/task' //任务 task
import address from '@/components/views/admin/body/address' //地址 address
import click from '@/components/views/admin/body/click' //记录 click
import reply from '@/components/views/admin/body/reply' //留言 reply
import enroll from '@/components/views/admin/body/enroll' //报名 enroll
import server from '@/components/views/admin/body/server' //服务 server
import integral from '@/components/views/admin/body/integral' //积分 integral
import picture from '@/components/views/admin/body/picture' //图片 picture
import video from '@/components/views/admin/body/video' //视频 video
import live from '@/components/views/admin/body/live' //直播 video
import choice from '@/components/views/admin/body/choice' //答题 choice
import info from '@/components/views/admin/body/info' //图文数据 info
import activity from '@/components/views/admin/body/activity' //activity 活动
import train from '@/components/views/admin/body/train' //train 培训数据
import navigation from '@/components/views/admin/body/navigation' //navigation 导航
import page from '@/components/views/admin/body/page' //page 页面数据
import talents from '@/components/views/admin/body/talents' //talents 人才
import chart from '@/components/views/admin/body/chart' //chart 图表
import product from '@/components/views/admin/body/product' //product 产品
import cache from '@/components/views/admin/body/cache' //cache 缓存

//展示前端
import bwg_template from '@/components/views/web/bwg/_layout/template' //模版
import bwg_index from '@/components/views/web/bwg/home_index' //首页
import list_news from '@/components/views/web/bwg/list_news' //新闻列表
import show_news from '@/components/views/web/bwg/show_news' //新闻详细
import list_activity from '@/components/views/web/bwg/list_activity' //活动列表
import show_activity from '@/components/views/web/bwg/show_activity' //活动详细
import list_voice from '@/components/views/web/bwg/list_voice' //语音导览列表
import show_voice from '@/components/views/web/bwg/show_voice' //语音导览详细
import list_zhi from '@/components/views/web/bwg/list_zhi' //知识列表
import show_zhi from '@/components/views/web/bwg/show_zhi' //知识详细
import show_special from '@/components/views/web/bwg/show_special' //专题详细
import show_project from '@/components/views/web/bwg/show_project' //专题详细
import list_info from '@/components/views/web/bwg/list_info' //专题列表
import show_info from '@/components/views/web/bwg/show_info' //专题详细
import list_map from '@/components/views/web/bwg/list_map' //地图列表
import list_info_a from '@/components/views/web/bwg/list_info_a' //展览荟萃
import list_info_b from '@/components/views/web/bwg/list_info_b' //椒江文保
import show_info_b from '@/components/views/web/bwg/show_info_b' //椒江文保
import list_info_c from '@/components/views/web/bwg/list_info_c' //椒江非遗
import show_info_c from '@/components/views/web/bwg/show_info_c' //椒江非遗
import list_interactive from '@/components/views/web/bwg/list_interactive' //互动
import users_index from '@/components/views/web/bwg/users/index' //用户主页

//椒江总工会
import jjgh_template from '@/components/views/jjgh/_layout/template' //模版
import add_users_a from '@/components/views/jjgh/add_users_a' //首页
import add_users_c from '@/components/views/jjgh/add_users_c' //首页
import add_users_d from '@/components/views/jjgh/add_users_d' //首页
import sqrh from '@/components/views/jjgh/sqrh' //申请入会
import sqjh from '@/components/views/jjgh/sqjh' //申请建会

import pfwq from '@/components/views/jjgh/pfwq' //普法维权
import xxxc from '@/components/views/jjgh/xxxc' //学习宣传
import cgfw from '@/components/views/jjgh/cgfw' //产改服务
import jnts from '@/components/views/jjgh/jnts' //技能提升
import ndjs from '@/components/views/jjgh/ndjs' //劳动竞赛
import yzcx from '@/components/views/jjgh/yzcx' //劳动竞赛
import knbf from '@/components/views/jjgh/knbf' //困难帮扶
import lmgj from '@/components/views/jjgh/lmgj' //劳模工匠
import gjsb from '@/components/views/jjgh/gjsb' //工匠申报
import zgwh from '@/components/views/jjgh/zgwh' //职工文化
import gfhx from '@/components/views/jjgh/gfhx' //共富惠享
import gfhx_show from '@/components/views/jjgh/gfhx_show' //共富惠享
import lxy from '@/components/views/jjgh/lxy' //共富惠享
import er from '@/components/views/jjgh/er' //共富惠享
import hy from '@/components/views/jjgh/hy' //核验

//网易房产
import wyfc_template from '@/components/views/wyfc/_layout/template' //模版
import wyfc_index from '@/components/views/wyfc/wyfc_index' //首页
import wyfc_show from '@/components/views/wyfc/wyfc_show' //首页
import wyfc_news from '@/components/views/wyfc/wyfc_news' //首页
import wyfc_index_show from '@/components/views/wyfc/wyfc_index_show' //详细

Vue.use(Router)


const router = new Router({
	routes: [{
			//椒江工会
			path: '/web/jjgh/', //用户
			name: 'jjgh_template',
			component: jjgh_template,
			children: [{
				path: 'sqrh',
				name: '申请入会',
				component: sqrh,
			},{
				path: 'sqjh',
				name: '申请建会',
				component: sqjh,
			},{
				path: 'lmgj',
				name: '劳模工匠',
				component: lmgj,
			},{
				path: 'gjsb',
				name: '工匠申报',
				component: gjsb,
			},{
				path: 'pfwq',
				name: '普法维权',
				component: pfwq,
			},{
				path: 'xxxc',
				name: '学习宣传',
				component: xxxc,
			},{
				path: 'jnts',
				name: '技能提升',
				component: jnts,
			}, {
				path: 'zgwh',
				name: '职工文化',
				component: zgwh,
			},{
				path: 'ndjs',
				name: '劳动竞赛',
				component: ndjs,
			},{
				path: 'yzcx',
				name: '驿站查询',
				component: yzcx,
			},{
				path: 'cgfw',
				name: '产改服务',
				component: cgfw,
			},{
				path: 'gfhx_show',
				name: '共富惠享',
				component: gfhx_show,
			},{
				path: 'gfhx',
				name: '共富惠享',
				component: gfhx,
			},{
				path: 'hy',
				name: 'hy',
				component: hy,
			},{
				path: 'er',
				name: 'er',
				component: er,
			},{
				path: 'lxy',
				name: '疗休养',
				component: lxy,
			},{
				path: 'knbf',
				name: '困难帮扶',
				component: knbf,
			},{
				path: 'add_users_a',
				name: '添加用户',
				component: add_users_a,
			}, {
				path: 'add_users_c',
				name: 'add_users_c',
				component: add_users_c,
			}, {
				path: 'add_users_d',
				name: 'add_users_d',
				component: add_users_d,
			}]
		},{
			//网易房产
			path: '/web/wyfc/', //用户
			name: 'wyfc_template',
			component: wyfc_template,
			children: [{
				path: 'wyfc_index',
				name: '首页',
				component: wyfc_index,
			},{
				path: 'wyfc_index_show',
				name: 'wyfc_index_show',
				component: wyfc_index_show,
			},{
				path: 'wyfc_show',
				name: 'wyfc_show',
				component: wyfc_show,
			},{
				path: 'wyfc_news',
				name: 'wyfc_news',
				component: wyfc_news,
			}]
		}]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js